module.exports = __webpack_public_path__ + "img/15.f1f14904.png";